import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  ApplyProposalTemplateMutation as _ApplyProposalTemplateMutation,
  ApplyProposalTemplateInput,
} from '@/gql/graphql';

const ApplyProposalTemplateMutation = graphql(`
  mutation ApplyProposalTemplate($input: ApplyProposalTemplateInput!) {
    applyProposalTemplate(input: $input) {
      id
    }
  }
`);

const useApplyProposalTemplate = (
  options?: UseMutationOptions<
    _ApplyProposalTemplateMutation,
    unknown,
    ApplyProposalTemplateInput
  >
) => {
  return useMutation({
    mutationFn: (input: ApplyProposalTemplateInput) => {
      return gqlClient.request(ApplyProposalTemplateMutation, { input });
    },
    ...options,
  });
};

export default useApplyProposalTemplate;
